import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { EXCHANGE_ACCOUNT_COLUMN, EXCHANGE_ACCOUNT_MODULE } from "../constants/accountSettingsConstants";

export const setExchangeAccountPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: EXCHANGE_ACCOUNT_MODULE,
        default_columns: EXCHANGE_ACCOUNT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
